export const isIe = (typeof window !== "undefined") && (/Trident\/|MSIE /.test(window.navigator.userAgent));

export const isFullScreenWidth = (element) => {
    if (!element) {
        return;
    }

    const width = element.offsetWidth;
    const fullScreenWidth = document.body.offsetWidth;
    return width === fullScreenWidth;
}

export const isDesktopView = (settings) => {//not in mobile responsive mode
    let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return windowWidth > settings.Mobile.breakpoint;
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/util/detect.js